import { render } from "./PartnerProsper.vue?vue&type=template&id=275b89e6"
import script from "./PartnerProsper.vue?vue&type=script&lang=js"
export * from "./PartnerProsper.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__